import httpService from "./httpService.js"

export const getAllOrdersService = (page, limit, q, status) => {
    return httpService(`/shop_admin/order_service_admin_panel/?page=${page}&limit=${limit}&status=${status}${q ? `&q=${q}` : ""}`, "get");
}

export const getSingleOrderService = (orderCode) => {
    return httpService(`/shop_admin/order_service_admin_panel/${orderCode}/`, "get");
}

export const editOrderStatusService = (orderCode, data) => {
    return httpService(`/shop_admin/order_service_admin_panel/${orderCode}/`, "patch", data);
}

export const editServiceStatusOfAnOrderService = (serviceCode, data) => {
    return httpService(`/shop_admin/service_admin_panel/${serviceCode}/`, "patch", data);
}